import { mediaData } from '@/mocks/homeData';

export default function Media() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-accent-100 text-accent-700 rounded-full mb-3 whitespace-nowrap">
            <i className="ri-play-circle-line mr-1"></i>精彩回放
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            精彩视频
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            爆料事件全复盘，视频讲解更直观易懂
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {mediaData.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 border border-background-200/60 rounded-xl overflow-hidden hover:border-background-300/60 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.target as HTMLImageElement).style.display = 'none';
                    const parent = (e.target as HTMLImageElement).parentElement;
                    if (parent) {
                      parent.style.display = 'none';
                    }
                  }}
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:bg-primary-600 transition-colors">
                    <i className="ri-play-fill text-white text-xl md:text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 text-xs font-medium bg-accent-500 text-white rounded-md whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-3 right-3">
                  <span className="px-2 py-0.5 text-xs bg-black/60 text-white rounded-md whitespace-nowrap backdrop-blur-sm">
                    {item.duration}
                  </span>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm font-medium text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <div className="mt-2 flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次观看</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}